<template>
  <div class="info">
    <div class="product-box" :class="isnew===1?'isnew':'isold'">
      <div
        class="product-item"
        ref="ele"
        v-for="(item,index) in product.attrValue"
        :key="item.attrId"
        :class="[step>=index ? 'selected attr'+item.attrId : 'attr'+item.attrId]"
      >
        <div class="head">
          <label>{{index+1}}.{{item.attrName}}</label>
        </div>
        <div class="attrs" v-if="item.attrType===1">
          <div v-if="index<4">
            <div
              class="item"
              v-for="(value,n) in item.valueList"
              :key="value.id"
              @click="specificationBtn(value.id,index,$event,n)"
              :class="[value.isShow?'':'noneActive',subIndex[index] == n?'active':'']"
            >{{value.value}}</div>
          </div>
          <div v-else>
            <div
              class="item"
              v-for="value in item.valueList"
              :key="value.id"
              @click="onClick(index,value.id,value.value,item.attrId)"
              :class="attrs.indexOf(value.id)>-1 ? 'active':''"
            >{{value.value}}</div>
          </div>
        </div>
        <div class="attrs" v-if="item.attrType===2">
          <div
            class="item"
            v-for="value in item.valueList"
            :key="value.id"
            @click="onCheck(value.id)"
            :class="attrs.indexOf(value.id)>-1 ? 'active':''"
          >{{value.value}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["product"],
  data() {
    return {
      step: 0,
      realstep: 0,
      line: 0,
      count: 0,
      isnew: 2,
      attrs: [],
      total: 1,
      attrid: 0,
      height: 0,
      productattrs: [],
      attrtext: "",
      selectArr: [], //存放被选中的值
      shopItemInfo: {}, //存放要和选中的值进行匹配的数据
      subIndex: []
    };
  },
  components: {},
  mounted: function() {
    window.scrollTo(0, 0);
    this.total = this.product.attrValue.length - 1;
    var self = this;
    self.checkItem();
  },
  methods: {
    toTop(height) {
      var gotoTop = function() {
        window.scrollTo(0, height);
        clearInterval(timer);
        timer = null;
      };
      var timer = setInterval(gotoTop, 300);
    },
    onClick(index, id, name, attrid) {
      let itemHeight = this.$refs.ele[index].offsetHeight;
      if (this.attrs[index] === undefined) {
        this.height +=itemHeight;
        this.attrs.push(id);
        this.step++;
        this.$emit("setStep", this.step);
        this.realstep++;
        this.toTop(this.height);
      } else {
        this.attrs.splice(index, 1, id);
      }
      this.$emit("getAttr", this.attrs);
    },
    onCheck(id) {
      let index = this.attrs.indexOf(id);
      if (this.attrs.indexOf(id) === -1) {
        this.attrs.push(id);
      } else {
        this.attrs.splice(index, 1);
      }
      this.$emit("getAttr", this.attrs);
    },
    specificationBtn: function(item, n, event, index) {
      var self = this;
      if (self.selectArr[n] != item) {
        var height = this.$refs.ele[n].offsetHeight;
        self.selectArr[n] = item;
        self.subIndex[n] = index;
        if (this.attrs[n] === undefined) {
          this.attrs.push(item);
          this.step++;
          this.$emit("setStep", this.step);
          this.height += height;
          this.toTop(this.height);
        } else {
          this.attrs.splice(n, 1, item);
        }
        this.$emit("getAttr", this.attrs);
      } else {
        // self.selectArr[n] = "";
        // self.subIndex[n] = -1; //去掉选中的颜色
      }
      self.checkItem();
    },
    checkItem: function() {
      var self = this;
      var option = self.product.attrValue;
      var result = []; //定义数组存储被选中的值
      for (var i in option) {
        result[i] = self.selectArr[i] ? self.selectArr[i] : "";
      }
      for (var i in option) {
        if (i < 4) {
          var last = result[i]; //把选中的值存放到字符串last去
          for (var k in option[i].valueList) {
            result[i] = option[i].valueList[k].id; //赋值，存在直接覆盖，不存在往里面添加name值
            option[i].valueList[k].isShow = self.isMay(result); //在数据里面添加字段isShow来判断是否可以选择
          }
          result[i] = last; //还原，目的是记录点下去那个值，避免下一次执行循环时避免被覆盖
        }
      }
      self.$forceUpdate(); //重绘
    },
    isMay: function(result) {
      for (let i = 0; i < this.product.attrs.length; i++) {
        if (
          this.product.attrs[i].indexOf(result.filter(d => d).join("|")) === 0
        ) {
          return true;
        }
      }
      return false; //匹配选中的数据的库存，若不为空返回true反之返回false
    }
  }
};
</script>
<style scoped>
.product {
  width: 100%;
  height: auto;
  font-size: 0.14rem;
  overflow: hidden;
  padding: 0.7rem 0 1rem 0;
}
.product-box {
  padding-top: 0rem;
  padding-bottom: 3rem;
}
.isnew .attr4,
.isnew .attr6,
.isnew .attr7,
.isnew .attr8,
.isnew .attr10 {
  display: none;
}
.product-item {
  border-bottom: solid #efefef 1px;
  padding: 10px 15px;
}
.product-item .head {
  font-size: 0.14rem;
  margin-bottom: 0.1rem;
  position: relative;
}
.product-item .head label {
  display: inline-block;
}
.product-item .attrs {
  display: flex;
  flex-wrap: wrap;
  display: none;
}
.product-item.selected .attrs {
  display: block;
}
.product-item .attrs .item {
  display: block;
  width: 3.2rem;
  position: relative;
  border: solid #efefef 1px;
  background: #fff;
  margin: 0.08rem 0 0.08rem 0rem;
  text-align: left;
  padding-left: 0.2rem;
  line-height: 0.5rem;
  height: 0.5rem;
  cursor: pointer;
  overflow: hidden;
}
.product-item .attrs .item.productActive {
  background-color: #1a1a29;
  color: #fff;
  border: 1px solid #1a1a29;
}
.product-item .attrs .item.noneActive {
  background-color: #ccc;
  opacity: 0.4;
  color: #000;
  pointer-events: none;
}
.product-item .attrs .disable {
  border: 1px dotted #ccc;
  color: #888;
  background: #f6f6f6;
  pointer-events: none !important;
}
.product-item .attrs .item:nth-child(2n) {
  margin-right: 0;
}
.product-item .attrs .item.active {
  background: #eff5ff;
  border: solid 1px #3782ff;
  color: #757575;
}
</style>